import React, {
    ReactElement, useState,
} from "react";
import { GrFormClose } from "react-icons/gr";
import Confirm from "../confirm/Confirm";

export interface ListGroup {
    id: string;
    name: string;
    iconUrl?: string;
}

export interface ListGroupContainer {
    id: string;
    title: string;
    groups: ListGroup[];
}

export interface SelectedGroup {
    parentId: string;
    itemId: string;
}

interface ListWithGroupsProps<T> {
    title: string | ReactElement;
    groups: ListGroupContainer[];
    items: T[];
    getKey: (item: T) => string;
    onSelected: (item: T) => void;
    onHide: () => void;
    shouldShow: boolean;
    children: (item: T, search: string, selectedGroup?: SelectedGroup) => ReactElement | null;
}

export function ListWithGroups<T>({
    groups, items, onSelected, shouldShow, onHide, children, getKey, title,
}: ListWithGroupsProps<T>): ReactElement {
    const [search, setSearch] = useState("");
    const [selectedGroup, setSelectedGroup] = useState<SelectedGroup>();

    const filtered = items.map(item => {
        const rendered = children(item, search, selectedGroup);
        return rendered ? (
            <button
                className="list-group-item text-start p-2 d-flex align-items-center"
                key={getKey(item)}
                onClick={() => onSelected(item)}
                type="button"
            >
                {rendered}
            </button>
        ) : null;
    }).filterNull();

    return (
        <Confirm shouldShow={shouldShow} onHide={onHide} size="xl" bodyClassName="p-0" className="p-0 ">
            <div className="h-50vh d-flex flex-column">
                <h5 className="mb-3 px-3 pt-3">{title}</h5>
                <div className="d-flex h-100 px-3 flex-grow-1">
                    <div className="col-xl-3 col-lg-3 col-md-3 me-3 border-end pe-3">
                        <input
                            className="form-control-sm form-control fs-6 mt-1 mb-3"
                            type="search"
                            placeholder="Search..."
                            value={search}
                            onChange={evt => setSearch(evt.target.value)}
                        />
                        {selectedGroup && (
                            <button
                                className="btn btn-none p-0 mx-0 my-2"
                                type="button"
                                onClick={() => setSelectedGroup(undefined)}
                            >
                                <GrFormClose />
                                {" "}
                                Clear Filters
                            </button>
                        )}
                        <div className="mt-2">
                            {groups.map(category => (
                                <div key={category.id} className="mb-4">
                                    <strong>{category.title}</strong>

                                    {category.groups.map(group => (
                                        <div className={`list-group-item list-group-item-action `
                                    + `border-start d-flex list-border rounded-0 mb-1 ps-2 ${
                                        (selectedGroup && selectedGroup?.itemId === group.id) ? "list-border-primary" : ""}`}
                                        >
                                            <button
                                                key={group.id}
                                                className="btn btn-none p-0 m-0"
                                                type="button"
                                                onClick={() => setSelectedGroup({
                                                    parentId: category.id,
                                                    itemId: group.id,
                                                })}
                                            >
                                                {group.name}
                                            </button>
                                        </div>
                                    ))}

                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col bg-white ">
                        <div className="list-group list-group-flush">
                            {filtered.isNotEmpty ? (
                                filtered
                            ) : (
                                <div className="list-group-item list-group-item-action text-center text-light mt-4">
                                    No results for the current search and filter
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </Confirm>

    );
}

ListWithGroups.defaultProps = {

};
